import { IForm } from '@/components/types'

export const searchFormConfig: IForm = {
  formItems: [
    {
      field: 'keyword',
      type: 'input',
      label: '关键词',
      placeholder: '请输入关键词',
      clearable: true
    },
    {
      field: 'teacher',
      type: 'select',
      label: '老师',
      placeholder: '请选择老师',
      options: [],
      clearable: true
    },
    {
      field: 'classname',
      type: 'select',
      label: '节目',
      placeholder: '请选择节目',
      options: [],
      clearable: true
    },
    {
      field: 'date',
      type: 'datepicker',
      label: '日期',
      clearable: false,
      otherOptions: {
        startPlaceholder: '起始日期',
        endPlaceholder: '结束日期',
        type: 'daterange',
        'value-format': 'YYYY-MM-DD',
        disabledDate: (date: Date) => {
          return new Date() < date
        }
      }
    }
  ]
}
